import React, { useState } from 'react';
import { Modal, Button } from 'antd';

interface ConfirmationModalProps {
    visible: boolean;
    onConfirm: () => Promise<void> | void;
    onCancel: () => void;
    title: string;
    description: string;
    confirmText?: string;
    cancelText?: string;
    confirmButtonProps?: any;
    cancelButtonProps?: any;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
    visible,
    onConfirm,
    onCancel,
    title,
    description,
    confirmText = 'Да',
    cancelText = 'Закрыть',
    confirmButtonProps = {},
    cancelButtonProps = {}
}) => {
    const [isLoading, setIsLoading] = useState(false);

    const handleConfirm = async () => {
        try {
            setIsLoading(true);
            await onConfirm();
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Modal
            title={title}
            open={visible}
            onCancel={onCancel}
            footer={[
                <Button
                    key="cancel"
                    type="primary"
                    onClick={onCancel}
                    disabled={isLoading}
                    {...cancelButtonProps}
                >
                    {cancelText}
                </Button>,
                <Button
                    key="confirm"
                    type="primary"
                    loading={isLoading}
                    onClick={handleConfirm}
                    {...confirmButtonProps}
                >
                    {confirmText}
                </Button>
            ]}
        >
            <p>{description}</p>
        </Modal>
    );
};

export default ConfirmationModal; 